import { render, staticRenderFns } from "./BulbIcon.vue?vue&type=template&id=6be9479e&scoped=true"
import script from "./BulbIcon.vue?vue&type=script&lang=ts"
export * from "./BulbIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be9479e",
  null
  
)

export default component.exports